import { IPublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Logout, Settings } from "@mui/icons-material";
import { Avatar, IconButton, ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { HtmlTooltip } from "../HtmlTooltip";
import './index.scss';

export const ProfileAvatarMenu: React.FC = () => {

    const { instance, accounts } = useMsal();
    const name = accounts[0] ? accounts[0].name ?? "" : "";
    const initials = name.match(/\b(\w)/g)?.join("");
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = (instance: IPublicClientApplication) => {
        instance.logoutPopup();
        navigate("/");
    };

    const navigate = useNavigate();

    return (<React.Fragment>
        <HtmlTooltip title={
            <>
                <Typography
                    variant="caption"
                >
                    {name}
                </Typography>
            </>
        } >
            <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                <Avatar sx={{
                    backgroundColor: (theme) => theme.palette.secondary.dark
                }} alt={name}>{initials}</Avatar>

            </IconButton>
        </HtmlTooltip>

        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            {/*<MenuItem>*/}
            {/*    <Avatar />Profile*/}
            {/*</MenuItem>*/}
            {/*<MenuItem>*/}
            {/*    <Avatar />My account*/}
            {/*</MenuItem>*/}
            {/*<Divider />*/}
            <MenuItem onClick={() => navigate("/settings")}>
                <ListItemIcon>
                    <Settings fontSize="small" />
                </ListItemIcon>
                Settings

            </MenuItem>
            <MenuItem onClick={() => handleLogout(instance)}>
                <ListItemIcon>
                    <Logout fontSize="small" />
                </ListItemIcon>
                Sign out
            </MenuItem>
        </Menu>
    </React.Fragment>);
};